import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';
import SettingsModal from '../components/SettingsModal';
import AdminDashboard from '../components/dashboards/AdminDashboard';
import UserDashboard from '../components/dashboards/UserDashboard';
import SuperAdminDashboard from '../components/dashboards/SuperAdminDashboard';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Dashboard = () => {
  const { user, getAuthHeader, checkSubscription } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Handle payment callback
  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const payment = searchParams.get('payment');
    
    if (sessionId && payment === 'success') {
      // Poll for payment status
      const pollPayment = async () => {
        try {
          const response = await axios.get(`${API}/payments/status/${sessionId}`, {
            headers: getAuthHeader()
          });
          
          if (response.data.payment_status === 'paid') {
            toast.success('Payment successful! Your subscription is now active.');
            checkSubscription();
          }
        } catch (e) {
          console.error('Payment status check failed:', e);
        }
      };
      
      // Poll a few times
      pollPayment();
      const interval = setInterval(pollPayment, 2000);
      setTimeout(() => clearInterval(interval), 10000);
      
      // Clear URL params
      navigate('/dashboard', { replace: true });
    } else if (payment === 'cancelled') {
      toast.info('Payment cancelled');
      navigate('/dashboard', { replace: true });
    }
  }, [searchParams, getAuthHeader, checkSubscription, navigate]);

  const renderDashboard = () => {
    switch (user?.role) {
      case 'super_admin':
        return <SuperAdminDashboard />;
      case 'admin':
        return <AdminDashboard />;
      default:
        return <UserDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-background" data-testid="dashboard">
      <Navbar onOpenSettings={() => setSettingsOpen(true)} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderDashboard()}
      </main>
      <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  );
};

export default Dashboard;
